import * as React from "react";
import client from "react-dom/client";
import { createPortal } from 'react-dom';

// Expose React globally
window.React = React;
window.ReactDOM = {
    client: client,
    createPortal: createPortal
};